import React from 'react';
// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// CSS
import './car.css';
import { CustomTypoH1, CustomTypoH3 } from '../../helper/headings';
import { CustomFilledBtn } from '../../helper/buttons';
// Mui icon
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { SolidImage, SolidImageCar, SolidImageCarMob, SolidImageLeft } from '../../components/Solid_Image';
import TravelPartner from '../../components/travel_partner';
// SVGs
import Section3Image from '../../assets/Car/car_3.svg'
import AppNavBar from '../../helper/appbar';

const CarPage = () => {
    const freeSignUp = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
    return (
        <div className='car-main'>
            <AppNavBar navType={'dark'} />
            <section className='car-main-section-1'>
                <Container>
                    <Row>
                        <Col md={6} lg={7} className='car-sec1-1'>
                            <h1 className='custom-typo-dark'>The car solution that helps you move faster</h1>
                            <CustomTypoH3 typo={`Private, group or special request? Move with us, we’ve got you covered.`} />
                            <div className='btn-icon-arrow' onClick={freeSignUp}>
                                <CustomFilledBtn title={'Sign up for free'} />
                                <ArrowForwardIcon />
                            </div>
                        </Col>
                        <Col md={6} lg={5}>
                            <img src={require('../../assets/Car/Img_3_Car.png')} alt={'Img_3_Car'} />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='car-main-section-2'>
                <Container>
                    <Row>
                        <Col lg={6} xl={6}>
                            <img src={require('../../assets/Car/car_2.png')} alt='car2-' />
                            <SolidImage imgPath={require('../../assets/Car/car_2.png')} />
                        </Col>
                        <Col lg={6} xl={6} className={'section2-content-text'}>
                            <CustomTypoH1 typo={`Personalized solution for car rental`} />
                            <p className='custom-typo-para'>We provide a single point of contact for all your rental car needs.
                                Select from a wide array of cars suited to all purposes; private,
                                executive, group, short- and long-term.</p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='car-main-section-3'>
                <div>
                    <CustomTypoH1 typo={`One platform from which you can move around`} />
                    <p className='custom-typo-para'>Our easy to use platform lets you book, manage and
                        automatically reconcile requests all from one place.
                        Kardinal car solutions help you save time by eliminating
                        the hassle of sourcing and booking a car manually.</p>
                </div>
                <div className='car-image-section3-img'>
                    <SolidImageCar imgPath={Section3Image} />
                    <SolidImageCarMob imgPath={Section3Image} />
                </div>
            </section>

            <section className='car-main-section-4'>
                <Container fluid >
                    <Row>
                        <Col xl={6} className="car-image-section4-img">
                            <SolidImage imgPath={require("../../assets/Car/car_5.png")} />
                            <SolidImageLeft imgPath={require("../../assets/Car/car_5.png")} />
                        </Col>
                        <Col xl={6} className="car-image-section4-text">
                            <CustomTypoH1 typo={`Quick turn around time for fast moving business`} />
                            <p className='custom-typo-para'>Last minute car rental need? Select from a pool of available
                                options that fit your budget so you don’t have to miss
                                that last minute business meeting.</p>
                            <p className='custom-typo-para'>Looking for something specific? You will be guided through
                                your needs by our care representative to ensure you get
                                what you need, when you need it.</p>
                        </Col>
                    </Row>
                </Container>
            </section>
            <TravelPartner />
        </div>
    );
};

export default CarPage;